import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import { Brands } from '../../common/constants';

const Container = styled.a.attrs({ className: 'ui__back-button' })`
  ${(props) => props.theme.type.base};
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  user-select: none;
  color: ${(props) => props.theme.colours.link} !important;
  text-decoration: none !important;
  &:hover > .link,
  &:focus > .link {
    color: ${(props) => props.theme.colours.accent};
  };
`;

const Chevron = styled(Icon)`
  ${(props) => `
    margin-right: ${props.theme.whitespace.small};
    display: flex;
    line-height: 1em;
    margin-top: 0px;
  `};
`;
const Label = styled.div`
  ${(props) => props.brand === Brands.Wireless ? props.theme.type.backButton : css`
    font-family: ${props.theme.type.h2.fontFamily};
    font-weight: bold;
    color: inherit;
    line-height: 1em;
    padding-top:1px;
  `};
`;

const onKeyPress = (handler, e) => {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    handler();
  }
};
const BackButton = ({ href, brand, children, onClick, disabled }) => (
  <Container
    className="back-button"
    role="link"
    aria-label={children}
    tabIndex={0}
    href={href}
    onKeyPress={(e) => !disabled && onKeyPress(onClick, e)}
    onClick={() => !disabled && onClick()}
  >
    <Chevron brand={brand} name="leftChevron" className="link" />
    <Label brand={brand} className="link">{children}</Label>
  </Container>
);
BackButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  brand: PropTypes.string
};
BackButton.defaultProps = {
  children: null,
  href: null,
  disabled: false,
  onClick: () => {}
};

export default BackButton;
